import {
  ThemePreference,
  useThemeMode,
} from "context/ThemeModeContext";
import {
  ThemeToggleButton,
  ThemeToggleMobileButton,
} from "styles/components/layout.styles";

const LABELS: Record<ThemePreference, string> = {
  system: "Theme: system (click for light)",
  light: "Theme: light (click for dark)",
  dark: "Theme: dark (click for system)",
};

const ICONS: Record<ThemePreference, string> = {
  system: "pi-desktop",
  light: "pi-sun",
  dark: "pi-moon",
};

interface ThemeToggleProps {
  variant?: "header" | "mobile";
}

export function ThemeToggle({ variant = "header" }: ThemeToggleProps) {
  const { preference, cyclePreference } = useThemeMode();
  const label = LABELS[preference];
  const icon = ICONS[preference];

  if (variant === "mobile") {
    return (
      <ThemeToggleMobileButton
        type="button"
        onClick={cyclePreference}
        aria-label={label}
        title={label}
      >
        <i className={`pi ${icon}`} aria-hidden />
        <span>Theme</span>
      </ThemeToggleMobileButton>
    );
  }

  return (
    <ThemeToggleButton
      type="button"
      onClick={cyclePreference}
      aria-label={label}
      title={label}
    >
      <i className={`pi ${icon}`} aria-hidden />
    </ThemeToggleButton>
  );
}
